<template>
  <div class="content">
    <van-nav-bar title="开通钱包" @click-left="onClickLeft">
      <template #left>
        <img style="width: 2.66667vw;height: 5.33333vw;display: inline-block;" src="../../../assets/right_icon2.png" alt="">
      </template>
<!--      <template #right>-->
<!--        <img style="width: 4.93333vw;height: auto;display: inline-block;" src="../../assets/car_icon.png" alt="">-->
<!--      </template>-->
    </van-nav-bar>
    <div class="wrapper">
      <div class="item-box">
        <div>
          <strong>姓名</strong>
          <input id="userName" class="input-item de2" placeholder="请输入您的姓名" />
        </div>
        <div class="hint-card">填写真实的个人信息，将上报银联中心核实并开通个人电子钱包</div>
      </div>
<!--      <div class="item-box">-->
<!--        <strong>银行卡号</strong>-->
<!--        <input id="bankNumber" @blur="bankNumberCheck" type="number" class="input-item de2" placeholder="请输入您的银行卡号码" />-->
<!--      </div>-->
<!--      <div class="item-box" :class="cardno==''?'item-box2':'item-box'">-->
<!--        <div>-->
<!--          <strong>银行卡名称</strong>-->
<!--          <input disabled style="background: #FFFFFF;" id="bankName" class="input-item de2" placeholder="请输入您的银行卡名称" />-->
<!--        </div>-->
<!--      </div>-->
      <div class="item-box">
        <strong>身份证</strong>
        <input id="idCard" class="input-item de2" placeholder="请输入您的身份证号码" />
      </div>
      <div class="item-box">
        <strong>手机号</strong>
        <input id="tel" maxlength="11" @blur="phoneCheck" type="tel" class="input-item de2" placeholder="请输入您的手机号码" />
      </div>
      <div class="item-box" style="position: relative;">
        <strong>验证码</strong>
        <input type="tel" id="msg" class="input-item de2" placeholder="请输入您的验证码" />
        <div class="msg-btn">
          <van-button
            size="small" type="primary" style="border: none;"
            v-if="!countDown"
            @click="sendVerifyCode"
          >获取验证码</van-button>
          <van-button
            slot="button"
            size="small"
            type="primary"
            disabled
            v-else
          >已发送{{countDown}}s</van-button>
        </div>
      </div>
      <div class="item-box">
        <strong>密码设置</strong>
        <input id="pwd1" class="input-item default" placeholder="请输入密码" />
      </div>
      <div class="btn-box" style="margin-top: 13.33333vw;">
        <van-button :disabled="isDisable" @click="onSubmit" style="background: #FDD80D;font-weight: bold;font-size: 4.53333vw;color: #282828;border: 0;padding: 2vw 1.33333vw;" round block type="info" native-type="submit">提交</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import "@/utils/initKeyBoard";
import {getPlugRandomKey, walletAccount,sendSms} from '@/api/wallet'
import axios from "axios";
import {Toast} from "vant";
import checkCard from "@/utils/checkCard";
export default {
  name: "openBurse",
  data() {
    return {
      isDisable:false,
      username: '',
      password: '',
      pwd1:'',
      idCard:'',
      tel: '',
      sms: '',
      phone:'',
      countDown: 0, // 倒计时
      rsaPublicKey:'',
      bank_name: '',
      bank_number:'',
      cardno: '',
      plugRandomKey: '' // 随机因子
    };
  },
  computed: {
    // 1.手机号码验证
    checkPhoneNumber () {
      // 1.1 当输入的手机号大于10位进行验证
      if (this.tel.length > 10) {
        return /[1][3,4,5,6,7,8][0-9]{9}$/.test(this.tel)
      } else {
        return true
      }
    },
    // 2.发送验证码按钮显示
    captchaDisable () {
      if (this.tel.length > 10) {
        return false
      } else {
        return true
      }
    }
  },
  beforeCreate: function() {
    // console.log('1')
    window.document.body.style.backgroundColor= '#fff'
  },
  beforeDestroy: function() {
    // console.log('2')
    window.document.body.style.backgroundColor= ''
  },
  mounted() {
    this.$nextTick(() => {
      this.pass1();
    })
    let rsaPublicKey = window.g.rsaPublicKey // rsa 公钥。 demo 中的 RSA 公钥是测试公钥。上生产时需更换为生产公钥。
    // if (process.env.VUE_APP_MODE === 'development' || process.env.VUE_APP_MODE === 'test') {
    //   // 开发环境下的执行操作
    //   rsaPublicKey = '30818902818100ac7916eeb5cc45b22e8a20ebb2cb11ac6b76678564300b70c3f09f8c0cb92076499556c2d60fa02a78d2d3d94a559ee5f65f5f89a94da88e5cade3bf6a412e4832d7380958fee0c9fe959a1e4c45c8c037a04f693210bb76fa0a3a9dbf3bee803e1365572b03848a7aa2e547257e5a8461073fd15b68b381f5bd76ec7fbc4d230203010001'
    //
    // } else {
    //   // 生产环境下的执行操作
    //   rsaPublicKey = '3082010a0282010100b219d36d00538fe607dfb5d366d6fd4205ba70710cf65a9f192b36193a5ecc6504ca30f3a97b594be744e4480a410220882b9b16f08ca780f05872c4297160bdf76f327e085634dd0b217681e5a55a005c3efb8834a71dfb268b816acce59143eba474f86acc9f86dc5af287e380b9c709ac4018597b621f5c08ccbecce3687a0d81c86d7ef3acc1eb8e46da52788607c7571313b476c50512e9eeab51829d23723d12b6d51816f3ccc7d37c66a6e92939ae5fe9f1b43fd0516b6fff72e3b09eb9c3b241dff81cbf2b8b3160ce0caf2ac705b2786abeac8a7c704664ef3bac8cd206c598b662582076f743893087416aff2ea05dca231b95133290e79ed6505d0203010001'
    // }

    this.rsaPublicKey = rsaPublicKey
    // console.log('rsaPublicKey',this.rsaPublicKey)
  },
  created() {
    this.getPlugRandomKeyDes()
  },
  methods: {
    phoneCheck(){ // 验证手机号
      this.tel = document.getElementById("tel").value
      var mobile = document.getElementById("tel").value
      console.log(this.tel)
      var myreg = /^1[3456789]\d{9}$/  // /^1[3|4|5|6|7|8|9][0-9]{9}$/;
      if(!myreg.test(mobile))
      {
        this.$toast('手机号码格式有误')
        document.getElementById("tel").value = ''
        this.tel = ''
        return false;
      }
    },
    bankNumberCheck(){ // 验证银行卡号
      console.log('this.bank_number',this.bank_number)
      this.bank_number = document.getElementById("bankNumber").value
      if (this.bank_number) {
        //验证银行卡号
        console.log(this.bank_number);
        var accound='https://ccdcapi.alipay.com/validateAndCacheCardInfo.json?cardNo='+this.bank_number+'&cardBinCheck=true'
        axios.get(accound)
          .then(response => {
            Toast.clear()
            var res = response.data
            console.log(response)
            this.cardno = response.data.validated
            console.log('sdf',this.cardno)
            if (res.validated){
              this.cardno = response.data.validated
              var bank_name = ''
              var bankcode = response.data.bank
              var  bankcardList = checkCard.bankcardList
              for (var i = 0, len = bankcardList.length; i < len; i++) {
                var bankcard = bankcardList[i];
                if (bankcode == bankcard.bankCode) {
                  bank_name = bankcard.bankName;
                  document.getElementById("bankName").value= bank_name
                  this.bank_name = bank_name
                  console.log(bank_name)
                }
              }
            } else {
              this.$toast('银行卡号错误,请重新输入')
            }
          }).catch(error => {
          Toast.clear()
          console.log(error)
        })
          .finally(() => this.loading = false)


      } else {
        // this.$toast('请输入银行卡号')
      }
    },
    getPlugRandomKeyDes(){ // plugRandomKey(随机数)
      getPlugRandomKey().then(res => {
        if(res.code == 200)
        {
          console.log('res',res.data)
          this.plugRandomKey =  res.data.msgBody.list[0].plugRandomKey
        }
        else
        {
          this.$toast(res.message)
          // this.$router.push('/');
        }
      })
    },
    // 4.发送验证码
    sendVerifyCode () {
      this.tel = document.getElementById("tel").value
      if (this.tel == ''){
        this.$toast('请输入手机号')
        return  false
      }
      // 4.1倒计时
      this.countDown = 60
      this.timeIntervalID = setInterval(() => {
        this.countDown--
        if (this.countDown === 0) {
          clearInterval(this.timeIntervalID)
        }
      }, 1000)
      // 4.2获取短信验证码
      var data = {
        phone: this.tel
      }
      // console.log(this.tel)
      sendSms(data).then(res => {
        if (res.code==200){
          this.$toast(res.data.rspResult)
          // console.log(res.data)
        }else {
          this.$toast(res.message)
        }
      })
    },
    pass1() {
      let that = this;
      window.passGuard1 = new passGuard(
        {
          //   "mappurl": "./send_mapping.jsp",//此处为了前端演示而屏蔽了，正常开发中需要此参数，该地址由后台人员提供
          "fixed": "H5fixed",//当fixed接口添加时，代表该输入框在fixed覆盖层上且覆盖层的ID为接口的值(在demo中覆盖层ID为"H5fixed")
          "maxLength": 12, // 最大输入长度
          "regExp1": "[\\S\\s]", // 输入过程限制的正则
          "regExp2": "[\\S\\s]{6,12}",
          "displayMode":0, // 显示形式,0:星号;1:明文,默认值0
          "callBack": that.callBack1, //成功回调
          "errorCallBack": that.errorCallBack1, //失败回调
          "focus": that.inputFocus1,//H5键盘获取焦点回调
          "blur": that.inputBlur1,//H5键盘失去焦点回调
          "rsaPublicKey": that.rsaPublicKey // rsa公钥
        });
      //初始化密码卫士,绑定键盘对象。数字参数：0代表全键盘，1代表数字键盘
      window.passGuard1.generate("pwd1", window.kb, "passGuard1", 1);
    },
    onClickLeft() {
      this.$router.go(-1);
    },
    onSubmit(){

      this.username = document.getElementById('userName').value
      // this.bank_name = document.getElementById("bankName").value
      // this.bank_number = document.getElementById("bankNumber").value
      this.idCard = document.getElementById("idCard").value
      this.tel = document.getElementById("tel").value
      this.sms = document.getElementById("msg").value
      var pwd = document.getElementById('pwd1').value
      // console.log(pwd)
      if (this.username == ''){
        this.$toast('用户名不能为空')
        return false;
      } else if ( this.idCard == ''){
        this.$toast('身份证号码不能空')
        return false;
      }else if ( this.tel == ''){
        this.$toast('手机号码不能空')
        return false;
      }else if ( this.sms == ''){
        this.$toast('验证码不能空')
        return false;
      } else if (pwd == ''){
        this.$toast('密码不能为空')
        return false;
      }else {
        this.isDisable = true // 防止多次 按钮不能
        passGuard1.setRandKey(this.plugRandomKey);
        //获取密文
        var miwen = passGuard1.getOutput();
        // console.log(miwen);
        var data  = {
          // bank_number: this.bank_number, // 银行卡号码，客户端验证
          // bank_name: this.bank_name,
          people: this.username,// 持卡人姓名
          phone: this.tel,// 持卡人姓名
          idcard: this.idCard, // 身份证
          code: this.sms, //
          encryptPwd: miwen,
          plugRandomKey:  this.plugRandomKey// 随机因子
        }
        console.log(data)
        walletAccount(data).then(res => {
          if (res.code==200){
            this.$toast(res.message)
            // console.log(res.data)
            setTimeout(() => {
              this.$router.push('/wallet');
            }, 1500)
            // this.isDisable = false // 防止多次 请交成功后才能点击
          }else {
            this.$toast(res.message)
            this.isDisable = false // 防止多次 请交成功后才能点击
            this.getPlugRandomKeyDes()
          }
        })
      }
    },
    callBack1() {
      // console.log("callBack");
    },
    errorCallBack1() {
      // console.log("errorCallBack");
    },
    inputFocus1() { // 获取焦点时的事件
      // console.log("获取焦点时的事件inputFocus");
    },
    inputBlur1() { // 获取焦点时的事件
      // console.log("输入框失去焦点inputBlur");
    },
    callBack2() {
      // console.log("callBack");
    },
  }
}
</script>

<style lang="scss" scoped>
.van-nav-bar {
  background: #FDD80D;color: #333333;font-weight: bold;font-size: 30px;
}
.item-box{
  padding: 20px 0;border-bottom: 1px solid #EBEBEB;
  .input-item{
    display: inline-block;font-size: 30px;border: none;color: #282828;line-height: 88px;height: 88px;
    width: 480px;
  }
  .msg-btn{
    position: absolute;right: 0;top: 32px;
  }
  strong{
    width: 220px;font-size: 30px;font-weight: 400;display: inline-block;
    color: #282828;text-align: left;

  }
}
.item-box2{
  height: 0;overflow: hidden;border-bottom: 0;padding: 0;
}
.wrapper{
  padding: 0 25px;
}
.van-button--small{

  border-radius: 35px;
  background: #56BB3B;
}
input::-webkit-input-placeholder {
  /* WebKit browsers */
  color: #BCBCBC;
}
input:-moz-placeholder {
  /* Mozilla Firefox 4 to 18 */
  color: #BCBCBC;
}
input::-moz-placeholder {
  /* Mozilla Firefox 19+ */
  color: #BCBCBC;
}
input:-ms-input-placeholder {
  /* Internet Explorer 10+ */
  color: #BCBCBC;
}
.hint-card{
  font-size: 24px;color: #58BB3B;padding-top: 10px;
}
</style>
